const comments = [
  {
    id: 1,
    name: '吃瓜群众小王',
    time: '2小时前',
    content: '终于找到51吃瓜网址最新入口了！之前那个域名打不开急死我了，这个防走失导航太实用了，收藏了收藏了！',
    likes: 128,
    avatar: '王',
  },
  {
    id: 2,
    name: '娱乐圈观察员',
    time: '5小时前',
    content: '51吃瓜官网全网最新入口更新速度真的快，昨天爆的料今天就有合集了，比我自己到处翻快多了。推荐给所有吃瓜爱好者！',
    likes: 96,
    avatar: '观',
  },
  {
    id: 3,
    name: '八卦小能手',
    time: '8小时前',
    content: '用51吃瓜网站入口好几个月了，每次域名换了都能在这里找到最新地址。移动端体验也不错，上班摸鱼必备神器哈哈！',
    likes: 75,
    avatar: '八',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">读者热评</h2>
          <p className="text-foreground-600 text-sm md:text-base">看看其他吃瓜群众怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {comments.map((c) => (
            <div
              key={c.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-primary-200/60 transition-colors duration-200"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-semibold text-primary-700">{c.avatar}</span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{c.name}</p>
                  <p className="text-xs text-foreground-500">{c.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">{c.content}</p>
              <div className="flex items-center gap-1.5 text-foreground-500">
                <i className="ri-thumb-up-line text-sm"></i>
                <span className="text-xs">{c.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}